import { useT } from "../../../shared/i18n";
import { MasterPane } from "../AdminListRow";
import type { LogFilters } from "./logFormat";
import { TraceDetail } from "./TraceDetail";
import { TraceList } from "./TraceList";
import type { TraceApi } from "./traceApi";

/**
 * Trace list (master) and one call (detail). Wide: side by side. Narrow: the
 * list or the call, one at a time; `openId` comes from the caller (the route
 * for the Logs section, local state in a user's Logs tab).
 */
export function LogsWorkspace({
  api,
  wide,
  filters,
  onFiltersChange,
  openId,
  onOpen,
  onClose,
  hrefFor,
  hideUserFilter,
  onOpenUser,
}: {
  api: TraceApi;
  wide: boolean;
  filters: LogFilters;
  onFiltersChange: (next: LogFilters) => void;
  openId: string | null;
  onOpen: (correlationId: string) => void;
  onClose: () => void;
  hrefFor?: (correlationId: string) => string;
  hideUserFilter?: boolean;
  onOpenUser?: (userId: string) => void;
}) {
  const t = useT();
  const list = (
    <MasterPane label={t("admin.logs.list.caption")}>
      <TraceList
        api={api}
        filters={filters}
        onFiltersChange={onFiltersChange}
        onOpen={onOpen}
        selectedId={openId}
        hrefFor={hrefFor}
        hideUserFilter={hideUserFilter}
      />
    </MasterPane>
  );
  const detail =
    openId === null ? null : (
      <TraceDetail
        key={openId}
        api={api}
        correlationId={openId}
        onNavigate={onOpen}
        onBack={wide ? undefined : onClose}
        onOpenUser={onOpenUser}
      />
    );
  if (!wide) return detail ?? list;
  return (
    <div className="grid min-w-0 grid-cols-[minmax(260px,340px)_minmax(0,1fr)] items-start gap-5">
      {list}
      {detail ?? (
        <p className="rounded-xl bg-sunken p-6 text-body text-fg-muted">
          {t("admin.logs.pick")}
        </p>
      )}
    </div>
  );
}
